/*global angular */
/*jslint node: true */

'use strict';

var quote = angular.module('quote', []);
quote.directive('quoteSlot', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'E',
        template: $templateCache.get('slots/quote/quote.html')
    };
}]);
